<template>
  <v-responsive>
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </v-responsive>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
  data() {
    return {
      //drawer:true
      //
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser["roles"]) {
        return this.currentUser["roles"].includes("ROLE_ADMIN");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser["roles"]) {
        return this.currentUser["roles"].includes("ROLE_MODERATOR");
      }

      return false;
    },
  },
  methods: {
    // logOut() {
    //   this.$store.dispatch('auth/logout');
    //   this.$router.push('/login');
    // }
  },
});
</script>
